import { ColumnData } from 'common/components/SearchBar';
import { ColumnActionsMode } from '@fluentui/react';
import { commonColumnProps } from 'common/utils/columnUtilities';

export const getColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'userOccupationTitle',
      name: 'Title',
      fieldName: 'userOccupationTitle',
      minWidth: 250,
      maxWidth: 250,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: 'Actions',
      fieldName: 'action',
      minWidth: 50,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
      isResizable: false,
    },
  ];
  return columns;
};
